import React, {Component} from 'react';
import {View, TouchableOpacity, StyleSheet, Platform} from 'react-native';

import computeProps from './utils/computeProps';


export default class RowNB extends Component {
    prepareRootProps() {

        var flattenedStyle = StyleSheet.flatten(this.props.style)

        var type = {
        	flexDirection: 'row',
          flex: ((this.props.size) ? (this.props.size) : (flattenedStyle && flattenedStyle.width) ? (Platform.OS == "web" ? "0 1 auto" : 0) : (Platform.OS == "web" ? "1 1 auto" : 1)),
          flexBasis: 'auto'
        }

        var defaultProps = {
            style: type
        }
        
        return computeProps(this.props, defaultProps);

    }

    setNativeProps(nativeProps) {
      this._root.setNativeProps(nativeProps);
    }

    render() {
      if(this.props.onPress){
        return(
            <TouchableOpacity onPress={this.props.onPress}
            {...this.prepareRootProps()}>
          <View
        ref={component => this._root = component}
        {...this.props}
        {...this.prepareRootProps()}
      >{this.props.children}</View>
          </TouchableOpacity>
      );
      }
      else{
        return(
          <View
            ref={component => this._root = component}
            {...this.props}
            {...this.prepareRootProps()}
          >{this.props.children}</View>
        );
      }
    }


}